<div>
  {{ productNumber | bbIban }}
</div>
